<!-- 盘点历史 -->

<template>
    <div class="orderSearch">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix ">
                        <el-date-picker
                          v-model="timeFrom"
                          value-format="yyyy/MM/dd-HH:mm:ss"
                          type="datetime"
                          class="dateTime"
                          :picker-options="pickerOptions0"
                          placeholder="选择开始日期时间">
                        </el-date-picker>
                        <el-date-picker
                          v-model="timeTo"
                          value-format="yyyy/MM/dd-HH:mm:ss"
                          type="datetime"
                          class="dateTime"
                          :picker-options="pickerOptions0"
                          placeholder="选择结束日期时间">
                        </el-date-picker>
                        <span class="types">
                            订单来源:
                            <el-select v-model="sourceValue">
                                <el-option
                                  v-for="item in sourceOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                            </el-select>
                        </span>
                        <span class="types">
                            支付类型:
                            <el-select v-model="payValue">
                                <el-option
                                  v-for="item in payOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                            </el-select>
                        </span>
                        <span class="types">
                            交易状态:
                            <el-select v-model="statusValue">
                                <el-option
                                  v-for="item in statusOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                            </el-select>
                        </span>
                        <span class="types typesSearch">
                            <span type="button" @click="getSearch">查询</span>
                        </span>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox" >
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:5.5%">序号</th>
                                <th style="width:10.5%">交易时间</th>
                                <th style="width:16%">订单号</th>
                                <th style="width:10%">订单来源</th>
                                <th style="width:10%">支付类型</th>
                                <th style="width:10%">交易状态</th>
                                <th style="width:10%">交易金额</th>
                                <th style="width:8%">优惠金额</th>
                                <th style="width:10%">实收金额</th>
                                <th style="width:10%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:workData.length>10}">
                                    <tr v-for="(item,ind) in workData">
                                        <td style="width:5.5%" >
                                            <span v-text="ind+1+curPage*pageSize" v-if="item.id"></span>
                                            <span v-if="!item.id"></span>
                                        </td>
                                        <td style="width:10.5%"> {{item.paymentTime | numberToMonthDate('')}}</td>
                                        <td style="width:16%" v-text="item.code"></td>
                                        <td style="width:10%" v-text="sourcetype[item.source]"></td>
                                        <td style="width:10%" v-text="paytype[item.channel]"></td>
                                        <td style="width:10%" v-text="statustype[item.status]"></td>
                                        <td style="width:10%" v-text="item.total"></td>
                                        <td style="width:8%" v-text="item.discount"></td>
                                        <td style="width:10%" v-text="item.amount"></td>
                                        <td style="width:10%;color:#3068ff;cursor:pointer;" >
                                            <span v-text="item.id?'详情':''" @click="orderDetail(item.id)"></span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <div class="pager flex flex-align-center prog">
                    <div class="pagerCon clearfix">
                        <el-progress :text-inside="true" :stroke-width="15" :percentage="progressNum" status="success" class="progress" v-if="progressBtn"></el-progress>
                        <span class="left excels" style="height:100%;line-height:30px;text-align:center;cursor:pointer;width:120px;background:green;border-radius: 8px;background-color: #3068fe;box-shadow: 0 2px 4px 0 #4a90e2;color:#fff;" @click="excel">导出Excel</span>
                        
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:(curPage>0)}" @click="changePage(false)"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(curPage+1)"></span>
                                <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:((curPage+1)<totalPage)}" @click="changePage(true)"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right" v-text="'第 '+(curPage+1)+' / '+totalPage+' 页'"></div>
                        <div class="totalPage flex flex-align-center right" v-text="'共'+totalElements+'条'"></div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="详情"
            :visible.sync="showPutAllMask"
            size="tiny">
            <div class="putAllInner">
                <div class="lossTotal flex flex-align-center">
                    <span class="span1">共</span>
                    <span class="span2 blue" v-text="curOrderData.count"></span>
                    <span class="span3">件商品</span>
                    <span class="span1">总计</span><span class="span2 red" v-text='curOrderData.total'></span>
                    <span class="span3">元</span>
                    <div class="right">
                        <span class="">座位号：</span>
                        <span v-text='curOrderData.tableNo'></span>
                    </div>
                </div>
                <div class="putAllTableBox">
                    <div >
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:80%;text-align:left;padding-left:10%;">商品名称</th>
                                    <th style="width:10%">数量</th>
                                    <th style="width:10%">金额</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in curOrderData.items">
                                            <td style="width:80%;text-align:left;padding-left:10%;"> <span v-text="item.productName"></span></td>
                                            <td style="width:10%"><span v-text="item.quantity"></span></td>
                                            <td style="width:10%"><span v-text="item.salesPrice"></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <table id="scrollBox" style="display:none"> 
        </table>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props:['curStoreId', 'pageSize'],
        data () {
            return {
                progressBtn:false,//进度条按钮
                showPutAllMask:false,//商品详情按钮

                curOrderData:[],
                pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                workData:[],
                curPage: 0,//当前页，用于切换页码
                totalPage: 1,//总共页
                totalElements: 0,//总共条
                paytype:{//支付类型
                    ALIPAY: '支付宝',
                    WECHATPAY: '微信',
                    CASH: '现金',
                    MEMBER : '会员支付',
                    ALIPAY_CASH : '线下支付宝',
                    WECHATPAY_CASH : '线下微信',
                },
                typeType:{'MEMBER_DEPOSIT':'充值','SALES':'消费'},//订单类型
                sourcetype:{//订单来源
                    POS: "收银台",
                    WEB: "电脑点单",
                    EMPLOYEE: "店员宝",
                    WEIXIN: "微信点单",
                    CONSUMER: "消费者，微信",
                    TAKEOUT: "三方外卖"
                },
                statustype:{//支付状态
                    UNSETTLED: "未结算",
                    UNFINISHED: "未处理",
                    FINISHED: "已处理",
                    CANCELED: "已取消",
                    REFUNDED: "已退",
                    FAIL: "失败",
                    NOTSURE: "支付中"
                },
                getBtn: true, // 控制翻页请求

                timeFrom:'',//开始时间
                timeTo:'',//截止时间
                //来源
                sourceOptions: [
                    {value: '',label: '全部'}, 
                    {value: 'POS',label: '收银台'}, 
                    {value: 'WEB',label: '电脑点单'},
                    {value: 'EMPLOYEE',label: '店员宝'},
                    {value: 'WEIXIN',label: '微信点单'}
                ],
                sourceValue: '',
                //支付类型
                payOptions: [
                    {value: '',label: '全部'},
                    {value: 'CASH',label: '现金'}, 
                    {value: 'ALIPAY',label: '支付宝'},
                    {value: 'WECHATPAY',label: '微信'},
                    {value: 'MEMBER',label: '会员支付'}
                ],
                payValue: '',
                //交易状态
               statusOptions: [
                    {value:'',label: '全部'},
                    {value: 'UNSETTLED',label: '未结算'}, 
                    {value: 'UNFINISHED',label: '未处理'}, 
                    {value: 'CANCELED',label: '已取消'},
                    {value: 'FINISHED',label: '已处理'},
                    {value: 'REFUNDED',label: '已退'},
                    {value: 'FAIL',label: '失败'},
                    {value: 'NOTSURE',label: '支付中'}
                ],
                statusValue: '',
                progressNum:10, //进度条
                doubleQ:true,
                searchUrl:''    
            }
        },
        methods: {
            getSearch(){
                if(this.timeTo&&this.timeFrom){
                    if(new Date(this.timeFrom)>new Date(this.timeTo)){
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        })
                        return;
                    }
                }else{
                    this.$message({
                        message: '必须输入开始时间和结束时间!',
                        customClass: 'error'
                    })
                    return; 
                }
                this.conditionFn();
                this.curPage = 0;
                setTimeout(()=>{
                    this.getWordData();
                },10)
            },
            //列表翻页
            changePage: function ( boo ) {
                if(!this.doubleQ){
                    return;
                }
                this.doubleQ = false;
                if ( boo ) {
                    if ( (this.curPage + 1) >= this.totalPage ) {
                        return;
                    }
                    this.curPage++;
                } else {
                    if ( this.curPage <= 0 ) {
                        return;
                    }
                    this.curPage--;
                }

                this.getWordData();
            },
            //搜索条件
            conditionFn(){
                let URL = '';
                this.timeFrom    ? URL += ('?from='+new Date(this.timeFrom).Format('yyyy-MM-dd hh:mm:ss')):'';
                this.timeTo      ? URL += ('&to='+new Date(this.timeTo).Format('yyyy-MM-dd hh:mm:ss')):'';
                this.sourceValue ? URL += ('&source='+this.sourceValue):'';
                this.payValue    ? URL += ('&channel='+this.payValue):'';
                this.statusValue ? URL += ('&status='+this.statusValue):'';
                this.searchUrl = URL;
            },
            //获取消费记录列表
            getWordData(){
                if ( !this.getBtn ) {
                    return;
                }
                this.getBtn = false;
                this.workData = [{},{},{},{},{},{},{},{},{},{}];
                this.$http.get(this.curStoreId+'/order/list'+this.searchUrl+'&pageNumber='+this.curPage+'&pageSize='+this.pageSize).then((res)=>{
                    this.workData = res.data.orders;
                    this.totalPage = (res.data.totalPages>=1?res.data.totalPages:1);
                    this.totalElements = res.data.totalElements;
                    if( this.workData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.workData.length; i < len; i++){
                            this.workData.push({})
                        }
                    }
                    setTimeout(()=>{
                        this.doubleQ = true;
                    },500)
                    this.getBtn = true;
                }).catch(()=>{
                    this.getBtn = true;
                })
            },
            //导出按钮
            excel(){
                if(!this.timeTo||!this.timeFrom){
                     this.$message({
                        message: '必须输入搜索时间',
                        customClass: 'error'
                    })
                    return
                }; 
                if(this.totalElements<=0){
                     this.$message({
                        message: '暂无数据！',
                        customClass: 'error'
                    })
                    return
                };
                if(this.totalElements>=10050){
                     this.$message({
                        message: '数据量太大，请细化检索条件！',
                        customClass: 'error'
                    })
                    return
                };
                this.$http.get(this.curStoreId+'/order/list'+this.searchUrl+'&pageNumber=0'+'&pageSize='+this.totalElements).then((res)=>{
                    // this.progressNum = 0;
                    let data = res.data.orders;
                    let html = '<tr>'+  
                                    '<td>交易时间</td>'+
                                    '<td>订单号</td>'+ 
                                    '<td>订单类型</td>'+
                                    '<td>订单来源</td>'+
                                    '<td>支付类型</td>'+
                                    '<td>交易状态</td>'+
                                    '<td>交易金额</td>'+
                                    '<td>优惠金额</td>'+
                                    '<td>实收金额</td>'+
                                '</tr>'
                            for(var i=0;i<data.length;i++){
                                html  +='<tr>'+
                                            '<td>'+new Date(data[i].paymentTime).Format('yyyy-MM-dd hh:mm:ss')+'</td>'+ 
                                            '<td>'+data[i].code+'</td>'+ 
                                            '<td>'+this.typeType[data[i].type]+'</td>'+ 
                                            '<td>'+this.sourcetype[data[i].source]+'</td>'+ 
                                            '<td>'+this.paytype[data[i].channel]+'</td>'+ 
                                            '<td>'+this.statustype[data[i].status]+'</td>'+ 
                                            '<td>'+data[i].total+'</td>'+ 
                                            '<td>'+data[i].discount+'</td>'+ 
                                            '<td>'+data[i].amount+'</td>'+ 
                                        '</tr>'
                            }
                    document.getElementById('scrollBox').innerHTML = html;
                    // this.progressNum = 100;
                    window.method5(scrollBox);
                })
            },
            orderDetail(id){
                this.$http.get('orders/'+id).then((res)=>{
                    this.showPutAllMask = true;
                    this.curOrderData = res.data;
                })
            }

        },
        created: function () {
            for (var i = 0; i < this.pageSize; i++) {
                this.workData.push({});
            }
        },
        mounted: function () {
            // this.getWordData();
        }
    }
</script>
<style lang="scss">
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
    @import "orderSearch.scss";
</style>



// WEBPACK FOOTER //
// orderSearch.vue?46770520